import { render, staticRenderFns } from "./LanterShippingDetail.vue?vue&type=template&id=bca20d16"
import script from "./LanterShippingDetail.ts?vue&type=script&lang=ts&external"
export * from "./LanterShippingDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./LanterShippingDetail.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports